import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { CensusSnapshot } from '../models/census-snapshot.model';
import { InpatientDetails } from '../models/inpatient-details.model';
import { ShiftRecord } from '../models/shift-record.model';

@Injectable({
    providedIn: 'root'
})
export class CensusSnapshotService {
    private apiUrl = `${this.config.appSettings.webApiServer}api/Patient/`;

    public loading: boolean;

    constructor(private config: ConfigService, private http: HttpClient) {
    }

    calculate(snapshot: CensusSnapshot) : number {
        if (!snapshot) return 0;
        return snapshot.admits + snapshot.transfersIn - snapshot.transfersOut - snapshot.discharges;
    }

    getInpatientShiftRecordDetails(shiftRecord: ShiftRecord) : Promise<InpatientDetails> {
        if (shiftRecord.id == 0) {
            return Promise.resolve(null);
        }
        const params = new HttpParams().set('shiftRecordId', shiftRecord.id.toString());

        return this.http.get<InpatientDetails>(`${this.apiUrl}GetInpatientShiftRecordDetails`, { params : params }).toPromise();
    }
}
